var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.series.length > 0
    ? _c(
        "div",
        { staticClass: "base-chart-container" },
        [
          _c("apex-chart", {
            ref: "chart",
            attrs: {
              type: _vm.type,
              series: _vm.series,
              options: _vm.fullOptions,
              height: _vm.resolvedHeight,
              width: _vm.width
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }